module.exports = __webpack_public_path__ + "static/admin-post-c63a575e628abd5d47aa473d1ce2d413.png";